import React from 'react';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 */
const RichAssetPreview = (reference) => {
  let content = null
  
  if (reference?.data?.target?.fields?.file?.url) {
    content = <img src={reference?.data?.target?.fields?.file?.url} alt={reference?.title || ''} />;
  }
  
  return content;
};

export default RichAssetPreview;
